import { faAngleDown } from '@fortawesome/pro-regular-svg-icons';
import Button from 'components/UI/V3/Button/Button';
import { Dropdown, DropdownContent, DropdownTrigger } from 'components/UI/V3/Dropdown';
import { DropdownItem } from 'components/UI/V3/Dropdown/Item/DropdownItem';
import { SelectionBar } from 'components/UI/V3/SelectionBar';
import { FunctionComponent } from 'react';
import type { TemplateFilterOption } from '../EmailTemplatesGallery';
import styles from './EmailTemplatesHeader.module.scss';

interface EmailTemplatesHeaderProps {
    options: TemplateFilterOption[];
    selectedFilter: string;
    onChange: (value: string) => void;
}

/**
 * Filter row shown above the cards in both `EmailTemplatesGallery` modes
 * (standalone full-window + picker inside the campaign wizard).
 *
 * The standalone top bar (logo + title + close) is no longer this component's
 * responsibility — it now lives directly inside the `FullWindowModalHeader`
 * rendered by `EmailTemplatesGallery` in standalone mode, so the chrome
 * matches every other full-window screen in V3.
 */
const EmailTemplatesHeader: FunctionComponent<EmailTemplatesHeaderProps> = ({ options, selectedFilter, onChange }) => {
    return (
        <div className={styles.filterRow}>
            <SelectionBar
                options={options}
                selectedId={selectedFilter}
                onSelect={onChange}
                className={styles.templateSelectionBar}
            />

            <Dropdown>
                <DropdownTrigger>
                    <Button
                        variant="green"
                        rightIcon={faAngleDown}
                        label={options.find(option => option.id === selectedFilter)?.name}
                        className={styles.templateFilterButton}
                    />
                </DropdownTrigger>

                <DropdownContent
                    minWidth={130}
                    align="end"
                >
                    {options.map(option => (
                        <DropdownItem
                            key={option.id}
                            onSelect={() => onChange(option.id)}
                        >
                            {option.name}
                        </DropdownItem>
                    ))}
                </DropdownContent>
            </Dropdown>
        </div>
    );
};

export default EmailTemplatesHeader;
